import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { getRecentTransactions } from '../../../services/financialService';

const RecentTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getRecentTransactions(10);
      setTransactions(data);
    } catch (err) {
      console.error('Error loading transactions:', err);
      setError(err?.message || 'Erro ao carregar transações');
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })?.format(value);
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('pt-BR');
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-900">Transações Recentes</h2>
        <button className="text-sm text-blue-600 hover:text-blue-700 font-medium">
          Ver Todas
        </button>
      </div>

      {loading ? (
        <div className="space-y-4">
          {[1, 2, 3]?.map((i) => (
            <div key={i} className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg animate-pulse">
              <div className="w-10 h-10 bg-gray-200 rounded-full" />
              <div className="flex-1">
                <div className="h-4 bg-gray-200 rounded w-1/3 mb-2" />
                <div className="h-3 bg-gray-200 rounded w-1/4" />
              </div>
              <div className="h-6 bg-gray-200 rounded w-24" />
            </div>
          ))}
        </div>
      ) : error ? (
        <div className="text-center py-8">
          <p className="text-red-600 mb-2">Erro ao carregar transações</p>
          <button
            onClick={fetchTransactions}
            className="text-sm text-blue-600 hover:text-blue-700"
          >
            Tentar Novamente
          </button>
        </div>
      ) : transactions?.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-500">Nenhuma transação encontrada</p>
        </div>
      ) : (
        <div className="space-y-4">
          {transactions?.map((transaction) => (
            <div
              key={transaction?.id}
              className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <div
                className="w-10 h-10 rounded-lg flex items-center justify-center"
                style={{
                  backgroundColor: transaction?.type === 'income' ? '#10b98115' : '#ef444415'
                }}
              >
                <Icon
                  name={transaction?.type === 'income' ? 'ArrowDownCircle' : 'ArrowUpCircle'}
                  size={20}
                  color={transaction?.type === 'income' ? '#10b981' : '#ef4444'}
                />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-gray-900">{transaction?.description}</p>
                <div className="flex items-center gap-2 mt-1">
                  <p className="text-xs text-gray-500">{formatDate(transaction?.date)}</p>
                  <span className="text-xs text-gray-400">•</span>
                  <p className="text-xs text-gray-500">{transaction?.bankAccount}</p>
                </div>
              </div>
              <div className="text-right">
                <p
                  className={`text-sm font-semibold ${
                    transaction?.type === 'income' ? 'text-green-600' : 'text-red-600'
                  }`}
                >
                  {transaction?.type === 'income' ? '+' : '-'} {formatCurrency(transaction?.amount)}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentTransactions;